import { SyntheticEvent } from 'react';
import { noop } from 'lodash';

/**
 * This method is available for components that need to raise a custom event (onChange event usually)
 * It should be avoided if possible but for cases when there's no input element or when react
 * doesn't allow raising change event (https://github.com/facebook/react/issues/10135) this is needed
 *
 * The other solution would be to not require passing event as second onChange's argument, but it would force us to create
 * new connectForm() function that will without events
 * @see (setFieldValue - https://gist.github.com/hubgit/e394e9be07d95cd5e774989178139ae8)
 * @param target either an html element or object with name,value props (name is optonal)
 */
const createFakeEvent = <T,>(target: T | { value: T, name: string | undefined }) => {
  return ({
    persist: noop,
    target,
    currentTarget: target,
    bubbles: false,
    cancelable: false,
    defaultPrevented: false,
    type: 'custom',
    eventPhase: 0,
    isTrusted: true,
    timeStamp: 0,
    isDefaultPrevented: noop,
    isPropagationStopped: noop,
    preventDefault: noop,
    stopPropagation: noop,
  } as unknown) as SyntheticEvent;
};

export default createFakeEvent;
